import { render, staticRenderFns } from "./IconPlay.vue?vue&type=template&id=48bcb44c&scoped=true"
import script from "./IconPlay.vue?vue&type=script&lang=js"
export * from "./IconPlay.vue?vue&type=script&lang=js"
import style0 from "./IconPlay.vue?vue&type=style&index=0&id=48bcb44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcb44c",
  null
  
)

export default component.exports